<template>
  <span>
    <input ref="file" type="file" class="form-control" placeholder="" style="" hidden @change="selectFile"  multiple>
<!--    multiple-->
<!--    accept=".png,.jpg,.jpeg,.gif"-->

    <a class="btn btn-primary" @click="fileUplaodControlClick"><i class="fa fa-upload"></i></a>

<!--    <div v-if="propsValue">-->
<!--      <a class="btn btn-danger" @click="fileRemove"><i class="fa fa-trash"></i></a>-->
<!--    </div>-->



  </span>
</template>

<script>

import util from "@/util/util";
import apiAdmin from "@/taylorCommon/apiAdmin";

export default {
  props: ["emmitBackParam","value","productId"],
  data: function () {
    return {
      selectdFiles:undefined,
      propsValue:this.value,
    };
  },
  watch: {
    propsValue(newVal){
      this.$emit('input', newVal);
    },
    value(newVal){
      this.propsValue = newVal
    }
  },
  methods: {
    fileUplaodControlClick(){
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    fileRemove(){
      if(this.propsValue==""){
        util.ShowMessage("沒有檔案")
        return;
      }

      let removeFileNamePath="/products/"+ this.productId +"/" + this.propsValue;
      apiAdmin.api_uploadFileRemove(removeFileNamePath).then((result)=>{
        this.$emit('uploadSuccess',this.emmitBackParam,result)

        this.propsValue=result.FileUrls;

        console.log(result);
      })

      this.propsValue = "";//QQ應該刪除檔案
      util.ShowMessage("已刪除")
    },
    selectFile(event){
      this.selectdFiles=event.target.files;

      //-------------檔案大小限制--------------------------
      const file = this.selectdFiles[0];

      if (!file) {
        alert('請選擇一個檔案');
        return;
      }

      if (file.size > 30*1024 * 1024) {
        alert('檔案太大 (需小於30MB)');
        return;
      }
      //---------------------------------------

      this.uploadFiles();
      event.target.value=null;

      // doc event.target.files 的內容
      // lastModified: 1612407992013
      // lastModifiedDate: Thu Feb 04 2021 11:06:32 GMT+0800 (台北標準時間) {}
      // name: "GPKlogo2.png"
      // size: 45641
      // type: "image/png"
      // webkitRelativePath: ""
    },
    uploadFiles(){
      let uploadFiles=this.selectdFiles;

      let option={
        fileFullName:this.propsValue,
        folder:"/products/" + this.productId + "/",
        // imgSizeW:1024,
        // imgSizeH:0,
      }

      // let result=await apiUBossCommonFileSec.api_UploadFiles(this.uploadType,this.fileName,uploadFiles,true);
      apiAdmin.api_uploadProductImage(uploadFiles,option).then((result)=>{
        this.$emit('uploadSuccess',this.emmitBackParam,result)

        this.propsValue=result.FileName;

        console.log(result);
      })


    },
    loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {


    //this.loadData()
  },
}
</script>

<style scoped>

</style>
